// Mock data for Organization Dashboard

export const venueOverviewData = [
    {
        id: 1,
        name: 'Bella Vista Downtown',
        address: '425 Fifth Avenue, Downtown',
        subscription: 'Premium',
        staffToday: 28,
        coversServed: 142,
        revenue: '$8,420',
        customerRating: 4.8
    },
    {
        id: 2,
        name: 'Bella Vista Waterfront',
        address: '89 Harbor View Drive, Marina District',
        subscription: 'Premium',
        staffToday: 24,
        coversServed: 98,
        revenue: '$6,890',
        customerRating: 4.6
    },
    {
        id: 3,
        name: 'Bella Vista Uptown',
        address: '156 Park Avenue, Uptown District',
        subscription: 'Standard',
        staffToday: 18,
        coversServed: 76,
        revenue: '$4,320',
        customerRating: 4.4
    }
];

export const currentStaffStatusData = {
    active: 103,
    onBreak: 21,
    absent: 12
};

export const shiftDistributionData = {
    amShift: 72,
    pmShift: 52,
    amPmCoverage: true
};

export const staffByLocationData = [
    { location: 'Downtown', active: 45, onBreak: 8, absent: 3 },
    { location: 'Waterfront', active: 32, onBreak: 6, absent: 4 },
    { location: 'Uptown', active: 26, onBreak: 7, absent: 5 }
];

export const weeklyRevenueData = {
    current: '$45.6K',
    change: '-12.3%',
    comparison: 'vs Yesterday',
    chartData: [
        { day: 'Mon', revenue: 9800 },
        { day: 'Tue', revenue: 8200 },
        { day: 'Wed', revenue: 7500 },
        { day: 'Thu', revenue: 8900 },
        { day: 'Fri', revenue: 9600 },
        { day: 'Sat', revenue: 11200 },
        { day: 'Sun', revenue: 10800 }
    ],
    dailyBreakdown: [
        { day: 'Mon', amount: '$9.8K' },
        { day: 'Tue', amount: '$8.2K' },
        { day: 'Wed', amount: '$7.5K' },
        { day: 'Thu', amount: '$8.9K' },
        { day: 'Fri', amount: '$9.6K' },
        { day: 'Sat', amount: '$11.2K' },
        { day: 'Sun', amount: '$10.8K' }
    ]
};

export const staffUtilizationData = [
    {
        location: 'Downtown',
        utilization: 85,
        staffCount: 24,
        color: '#007bff'
    },
    {
        location: 'Mall Branch',
        utilization: 72,
        staffCount: 18,
        color: '#28a745'
    },
    {
        location: 'Airport',
        utilization: 91,
        staffCount: 15,
        color: '#ffc107'
    },
    {
        location: 'Suburban',
        utilization: 68,
        staffCount: 12,
        color: '#dc3545'
    }
];

export const reportGeneratorData = [
    {
        id: 1,
        title: 'Sales Analytics',
        type: 'Financial',
        description: 'Comprehensive sales data and sales trends',
        duration: '2-3 minutes',
        lastGenerated: 'Last 2 hours ago'
    },
    {
        id: 2,
        title: 'Staff Performance',
        type: 'HR',
        description: 'Employee attendance, shift performance metrics',
        duration: '3-4 minutes',
        lastGenerated: 'Last 1 day ago'
    },
    {
        id: 3,
        title: 'Inventory Management',
        type: 'Operations',
        description: 'Stock levels, usage patterns, and cost analysis',
        duration: '1-2 minutes',
        lastGenerated: 'Last 3 hours ago'
    },
    {
        id: 4,
        title: 'Customer Analytics',
        type: 'Marketing',
        description: 'Guest demographics, feedback, and dining patterns',
        duration: '2-3 minutes',
        lastGenerated: 'Last 1 day ago'
    },
    {
        id: 5,
        title: 'Menu Performance',
        type: 'Operations',
        description: 'Item popularity, profitability, and seasonal trends',
        duration: '1-2 minutes',
        lastGenerated: 'Last 5 hours ago'
    },
    {
        id: 6,
        title: 'Operational Efficiency',
        type: 'Operations',
        description: 'Service times, table turnover, and workflow analysis',
        duration: '3-4 minutes',
        lastGenerated: 'Last 8 hours ago'
    }
];

export const restaurantOperationsData = {
    quickActions: [
        { id: 1, title: 'Schedule Weekend Staff', status: 'Urgent', action: 'Assign weekend staff for all venues', location: 'All Venues' },
        { id: 2, title: 'Hire Kitchen Staff', status: 'Active', action: 'Add food staff for Garden location', location: 'Garden Location' },
        { id: 3, title: 'Review Menu Pricing', status: 'Pending', action: 'Adjust seasonal pricing for February', location: 'All Venues' }
    ],
    pendingApprovals: 4
};

export const recentActivityData = {
    today: [
        {
            id: 1,
            type: 'staff_login',
            title: 'Staff login detected',
            description: 'New evening shift staff logged into system',
            location: 'Bella Vista Downtown',
            time: '2h',
            status: 'success'
        },
        {
            id: 2,
            type: 'configuration',
            title: 'Configuration sync completed',
            description: 'Venue settings synchronized successfully',
            location: 'Bella Vista Garden',
            time: '1h',
            status: 'info'
        },
        {
            id: 3,
            type: 'manager_login',
            title: 'Manager logged in',
            description: 'Restaurant manager accessed shift duties',
            location: 'Bella Vista Heights',
            time: '3h',
            status: 'success'
        }
    ],
    thisWeek: [
        {
            id: 4,
            type: 'staff_permissions',
            title: 'Staff permissions updated',
            description: 'Manager has redesigned out latest offerings',
            location: 'Bella Vista Uptown',
            time: '1d',
            status: 'warning'
        },
        {
            id: 5,
            type: 'payment_method',
            title: 'Payment method updated',
            description: 'Auto billing information successfully refreshed',
            location: 'Bella Vista Express',
            time: '1d',
            status: 'success'
        },
        {
            id: 6,
            type: 'performance_optimization',
            title: 'Performance optimization',
            description: 'Database optimization completed for better response times',
            location: 'Bella Vista Waterfront',
            time: '2d',
            status: 'info'
        },
        {
            id: 7,
            type: 'menu_update',
            title: 'Menu update deployed',
            description: 'New seasonal menu items added successfully',
            location: 'Bella Vista Garden',
            time: '3d',
            status: 'success'
        }
    ]
};